import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    PaymentItemService,
    PaymentItemPopupService,
    PaymentItemDialogComponent,
    PaymentItemPopupComponent,
    PaymentItemDeletePopupComponent,
    PaymentItemDeleteDialogComponent,
    paymentItemPopupRoute,
    PaymentItemResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...paymentItemPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        PaymentItemDialogComponent,
        PaymentItemDeleteDialogComponent,
        PaymentItemPopupComponent,
        PaymentItemDeletePopupComponent,
    ],
    entryComponents: [
        PaymentItemDialogComponent,
        PaymentItemPopupComponent,
        PaymentItemDeleteDialogComponent,
        PaymentItemDeletePopupComponent,
    ],
    providers: [
        PaymentItemService,
        PaymentItemPopupService,
        PaymentItemResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiPaymentItemModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item.module.ts